export type ApiKeyExpiryChoice = '90-days' | '1-year' | 'custom'

const DAY_SECONDS = 24 * 60 * 60
export const MAX_API_KEY_LIFETIME_SECONDS = 366 * DAY_SECONDS

export interface ApiKeyExpiryValue {
  expiresInSeconds: number | null
  expiresAt: Date | null
  error: string
}

export function apiKeyExpiryValue(
  choice: ApiKeyExpiryChoice,
  customDate: string,
  now = Date.now()
): ApiKeyExpiryValue {
  let expiresInSeconds: number
  if (choice === '90-days') expiresInSeconds = 90 * DAY_SECONDS
  else if (choice === '1-year') expiresInSeconds = 365 * DAY_SECONDS
  else {
    if (!customDate)
      return { expiresInSeconds: null, expiresAt: null, error: 'Choose an expiry date.' }
    const expiresAt = new Date(`${customDate}T23:59:59.999`)
    if (!Number.isFinite(expiresAt.getTime())) {
      return { expiresInSeconds: null, expiresAt: null, error: 'Choose a valid expiry date.' }
    }
    expiresInSeconds = Math.floor((expiresAt.getTime() - now) / 1000)
  }

  if (expiresInSeconds < 60) {
    return {
      expiresInSeconds: null,
      expiresAt: null,
      error: 'Expiry must be at least 60 seconds from now.'
    }
  }
  if (expiresInSeconds > MAX_API_KEY_LIFETIME_SECONDS) {
    return {
      expiresInSeconds: null,
      expiresAt: null,
      error: 'Expiry cannot be more than 366 days from now.'
    }
  }
  return {
    expiresInSeconds,
    expiresAt: new Date(now + expiresInSeconds * 1000),
    error: ''
  }
}
